(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smph-campaign-carousel"] && !Shopify.designMode) return;
  try {
    
  function initSmphCampaignCarousels() {
    document.querySelectorAll('[data-smph-campaign-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-carousel-dot]'));
      const prev = carousel.querySelector('[data-carousel-prev]');
      const next = carousel.querySelector('[data-carousel-next]');
      const autoplay = carousel.dataset.autoplay === 'true';
      const speed = Number(carousel.dataset.speed) || 5000;
      let index = 0;
      let timer;

      if (!track || slides.length < 2) return;

      const visibleCount = () => window.matchMedia('(min-width: 750px)').matches ? 3 : 1;
      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const update = () => {
        if (index > maxIndex()) index = 0;
        const slideWidth = slides[0].getBoundingClientRect().width;
        const gap = 5;
        track.style.transform = 'translateX(' + (-index * (slideWidth + gap)) + 'px)';
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      const goTo = (newIndex) => {
        const max = maxIndex();
        index = newIndex > max ? 0 : newIndex < 0 ? max : newIndex;
        update();
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => goTo(index + 1), speed);
        }
      };

      prev?.addEventListener('click', () => {
        goTo(index - 1);
        start();
      });

      next?.addEventListener('click', () => {
        goTo(index + 1);
        start();
      });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.carouselDot));
          start();
        });
      });


      let touchStartX = 0;
      let touchStartY = 0;
      const swipeThreshold = 40;

      carousel.addEventListener('touchstart', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        stop();
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
          goTo(index + (deltaX < 0 ? 1 : -1));
        }
        start();
      }, { passive: true });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);
      window.addEventListener('resize', update);

      update();
      start();
    });
  }

  document.addEventListener('DOMContentLoaded', initSmphCampaignCarousels);
  document.addEventListener('shopify:section:load', initSmphCampaignCarousels);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smph-google-reviews"] && !Shopify.designMode) return;
  try {
    
  function initSmphGoogleReviews() {
    document.querySelectorAll('[data-smph-google-reviews]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const track = section.querySelector('[data-review-track]');
      const slides = Array.from(section.querySelectorAll('[data-review-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-review-dot]'));
      const prev = section.querySelector('[data-review-prev]');
      const next = section.querySelector('[data-review-next]');
      let index = 0;

      if (!track || slides.length < 2) return;

      const visibleCount = () => window.matchMedia('(min-width: 990px)').matches ? 4 : 1;
      const maxIndex = () => Math.max(0, slides.length - visibleCount());

      const update = () => {
        if (index > maxIndex()) index = 0;
        const slideWidth = slides[0].getBoundingClientRect().width;
        track.style.transform = 'translateX(' + (-index * (slideWidth + 14)) + 'px)';
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      const goTo = (newIndex) => {
        const max = maxIndex();
        index = newIndex > max ? 0 : newIndex < 0 ? max : newIndex;
        update();
      };

      prev?.addEventListener('click', () => goTo(index - 1));
      next?.addEventListener('click', () => goTo(index + 1));

      dots.forEach((dot) => {
        dot.addEventListener('click', () => goTo(Number(dot.dataset.reviewDot)));
      });

      let touchStartX = 0;
      let touchStartY = 0;
      const swipeThreshold = 40;

      section.addEventListener('touchstart', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      }, { passive: true });

      section.addEventListener('touchend', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
          goTo(index + (deltaX < 0 ? 1 : -1));
        }
      }, { passive: true });

      window.addEventListener('resize', update);
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', initSmphGoogleReviews);
  document.addEventListener('shopify:section:load', initSmphGoogleReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smph-latest-promos"] && !Shopify.designMode) return;
  try {
    
  function updateSmphPromoLinks() {
    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    document.querySelectorAll('.smph-promo-section__tile').forEach((tile) => {
      if (!tile.dataset.desktopLink) tile.dataset.desktopLink = tile.getAttribute('href') || '';
      const mobileLink = tile.dataset.mobileLink;
      tile.setAttribute('href', isMobile && mobileLink ? mobileLink : tile.dataset.desktopLink);
    });
  }

  document.addEventListener('DOMContentLoaded', updateSmphPromoLinks);
  document.addEventListener('shopify:section:load', updateSmphPromoLinks);
  window.addEventListener('resize', updateSmphPromoLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smph-media-carousel"] && !Shopify.designMode) return;
  try {
    
  function initSmphMediaCarousels() {
    document.querySelectorAll('[data-smph-media-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('[data-media-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-media-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-media-dot]'));
      const autoplay = carousel.dataset.autoplay === 'true';
      const speed = Number(carousel.dataset.speed) || 5000;
      let index = 0;
      let timer;

      if (!track || slides.length < 2) return;

      const update = () => {
        track.style.transform = 'translateX(' + (-index * 100) + '%)';
        dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
      };

      const goTo = (newIndex) => {
        index = newIndex >= slides.length ? 0 : newIndex < 0 ? slides.length - 1 : newIndex;
        update();
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          timer = window.setInterval(() => goTo(index + 1), speed);
        }
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.mediaDot));
          start();
        });
      });


      let touchStartX = 0;
      let touchStartY = 0;
      const swipeThreshold = 40;

      carousel.addEventListener('touchstart', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        stop();
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        if (Math.abs(deltaX) >= swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
          goTo(index + (deltaX < 0 ? 1 : -1));
        }
        start();
      }, { passive: true });

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', start);

      update();
      start();
    });
  }

  document.addEventListener('DOMContentLoaded', initSmphMediaCarousels);
  document.addEventListener('shopify:section:load', initSmphMediaCarousels);

  } catch(e) { console.error(e); }
})();
})();
